export const dataBaseUrl = import.meta.env.VITE_DATA_BASE_URL as string ?? ''
